import Vue from 'vue'
import { AutoComplete } from 'ant-design-vue'
import { savePreviousData, errorService, instance } from '@/services/api'
import _ from 'lodash'
Vue.use(AutoComplete)

export default Vue.extend({
  template: `
    <div class="a-gcell">
      <a-spin :spinning="loading">
        <a-auto-complete
            class="w-100"
            size="small"
            v-model="value"
            :value="value"
            option-label-prop="title"
            style="width: 200px"
            @focus="savePreviousData(value)"
            @search="onSearch($event)"
            @select="saveData"
            ref="txt-autocomplete"
            :autoFocus="true"
          >
            <template slot="dataSource" v-if="params.colDef['cellRendererParams'].name === 'takeoff_Name'">
              <a-select-option
                key="-1"
                title="new"
                value="new"
                style="text-decoration: underline;color:blue"
                v-if="params.colDef['cellRendererParams'].name === 'takeoff_Name' && (role === 'Admin' ||  role === 'Project Manager' || role === 'Project Reviewer' || role === 'Engagement Manager')"
                >
                  <a>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add New
                  </a>
                </a-select-option
              >
              <a-select-opt-group v-for="(result, index) in currentResult" :key="index">
                <span slot="label" class="select-text"> {{ result.takeoffGrouping }} </span>
                <a-select-option
                  v-for="(item, index2) in result['takeoffs']"
                  :key="item.key+'-'+'$##'+result.takeoffGrouping+'$##'+item.takeoff"
                > 
                  <a-tooltip placement="left" :title="item.takeoff + ' - ' + formatCurrency(item.unitCost) + ' - ' + item.unit + ' - ' + formatLife(item.life)">
                    <a-row :gutter="10">
                      <a-col :span="10"><span class="autocomplete-list">{{ item.takeoff }}</span></a-col>
                      <a-col :span="6"><span class="autocomplete-list right">{{ formatCurrency(item.unitCost) }}</span></a-col>
                      <a-col :span="3"><span class="autocomplete-list">{{ item.unit }}</span></a-col>
                      <a-col :span="5"><span class="autocomplete-list">{{ formatLife(item.life) }}</span></a-col>
                    </a-row>
                  </a-tooltip>
                </a-select-option>
              </a-select-opt-group>
            </template>
            <template slot="dataSource" v-else>
              <a-select-option
                key="-1"
                title="new"
                value="new"
                style="text-decoration: underline;color:blue"
                v-if="params.colDef['cellRendererParams'].name === 'takeoff_Name' && (role === 'Admin' ||  role === 'Project Manager' || role === 'Project Reviewer' || role === 'Engagement Manager')"
                >
                  <a>
                    <i class="fa fa-plus" aria-hidden="true"></i>
                    Add New
                  </a>
                </a-select-option
              >
              <a-select-option
                v-for="(item, index) in currentResult"
                :key="item.id"
                :title="item[params.colDef['cellRendererParams'].name]"
                :value="item[params.colDef['cellRendererParams'].name]"
              >
                {{ params.colDef['cellRendererParams'].name === 'takeoff_Name' ? item.option : item[params.colDef['cellRendererParams'].name] }}
              </a-select-option>
            </template>
        </a-auto-complete>
      </a-spin>
    </div>
    `,

  data() {
    return {
      value: null,
      loading: false,
      currentResult: null,
      savePreviousData: savePreviousData,
      prevSearchKey: '',
      prevResult: [],
      role: null,
    }
  },
  created() {
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.value = this.params.value
  },
  methods: {
    onSearch(searchText) {
      const url = `${this.params.colDef['cellRendererParams'].dropdownURL}${searchText.slice(0, 3)}`
      if (((this.prevSearchKey !== searchText && searchText.length === 3) || (this.prevSearchKey === '' && searchText.length >= 3))) {
        this.loading = true
        this.prevSearchKey = searchText
        this.currentResult = []
        instance.get(`${url}`).then(res => {
          const result = _.get(res.data, 'result', [])
          if (this.params.colDef['cellRendererParams'].name === 'takeoff_Name') {
            this.currentResult = result
            this.prevResult = JSON.stringify(this.currentResult)
            const oldData = this.prevResult.length > 0 && this.value ? JSON.parse(this.prevResult) : []
            this.currentResult = oldData.filter(data => {
              if ((data['takeoffGrouping'].toLowerCase()).includes(this.value.toLowerCase())) {
                return data
              } else {
                const takeoffs = [...data['takeoffs']]
                data['takeoffs'] = []
                takeoffs.forEach(element => {
                  if ((element.takeoff).toLowerCase().includes(this.value.toLowerCase())) {
                    data['takeoffs'].push(element)
                  }
                })
                if (data['takeoffs'].length > 0) {
                  return data
                }
              }
            })
          } else {
            this.currentResult = result
            this.prevResult = JSON.stringify(this.currentResult)
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          errorService(err)
        })
      } else {
        const oldData = this.prevResult.length > 0 && searchText ? JSON.parse(this.prevResult) : []
        this.currentResult = oldData.filter(data => {
          if (this.params.colDef['cellRendererParams'].name === 'takeoff_Name') {
            if ((data['takeoffGrouping'].toLowerCase()).includes(searchText.toLowerCase())) {
              return data
            } else {
              const takeoffs = [...data['takeoffs']]
              data['takeoffs'] = []
              takeoffs.map(takeoff => {
                if ((takeoff['takeoff']).toLowerCase().includes(searchText.toLowerCase())) {
                  data['takeoffs'].push(takeoff)
                }
              })
              if (data['takeoffs'].length > 0) {
                return data
              }
            }
          } else {
            if ((data[this.params.colDef['cellRendererParams'].name]).toLowerCase().includes(searchText.toLowerCase())) {
              return data
            }
          }
        })
      }
    },
    saveData(value, keySelected) {
      const splitKeys = keySelected['key'].split('-')
      const splitForName = keySelected['key'].split('$##')
      const splitData = [parseInt(splitKeys[1]), splitForName[1], splitForName[2]]
      const key = splitData[0]
      switch (this.params.colDef['cellRendererParams'].type) {
        case 'dynamicTable':
          this.$root.$emit('handleChange', value, this.params.data, this.params.colDef.field, this.params.rowIndex, splitData)
          break
        case 'analysisSheet':
          this.$root.$emit('saveAnalysisData', value, this.params.data, this.params.colDef.field, this.params.data.columnId, key)
          break
        default:
          this.$root.$emit('saveTenantData', this.params.colDef.field, value, this.params.colDef.headerName, this.params.data, key)
          break
      }
    },
    formatCurrency(value) {
      const settings = JSON.parse(localStorage.getItem('userSettings'))
      return new Intl.NumberFormat(settings.currency.currencyFormate, { style: 'currency', currency: settings.currency.currency }).format(value)
    },
    formatLife(value) {
      if (value > 1) {
        return `${value} Years`
      } else {
        return `${value} Year`
      }
    },
    getValue() {
      return this.value
    },
  },
})
